import { Box } from '@mui/material';
import { FormTitleBox, LoadingSkeleton, ConfirmationDialog, PaginationTable } from '../../../common/components';
import QualityCommentsDataTable from './components/QualityCommentsDataTable';
import QualityCommentsFilters from './components/QualityCommentsFilters';
import QualityCommentDialog from './components/QualityCommentDialog';
import { useQualityCommentsTable } from './hooks/useQualityCommentsTable';
import FactCheckIcon from '@mui/icons-material/FactCheck';

const QualityCommentsTable = () => {
  const {
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    searchTerm,
    allotments,
    lots,
    selectedAllotment,
    selectedLot,
    dialogOpen,
    editMode,
    selectedComment,
    deleteConfirmOpen,
    commentToDelete,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleSelectAllotment,
    handleSelectLot,
    handleOpenDialog,
    handleCloseDialog,
    handleInputChange,
    handleSave,
    handleDelete,
    handleConfirmDelete,
    handleCancelDelete,
  } = useQualityCommentsTable();

  return (
    <Box>
      <FormTitleBox
        title="Seguimiento | Comentarios de Calidad"
        showButton={false}
        showSearch={true}
        searchLabel="Buscar comentario por tarea, lote o loteo"
        searchValue={searchTerm}
        onSearchChange={handleSearch}
        searchSize="medium"
        buttonIcon={FactCheckIcon}
      />

      <QualityCommentsFilters
        allotments={allotments}
        lots={lots}
        selectedAllotment={selectedAllotment}
        selectedLot={selectedLot}
        onSelectAllotment={handleSelectAllotment}
        onSelectLot={handleSelectLot}
      />

      <QualityCommentsDataTable
        data={data}
        isLoading={isLoading}
        onEdit={handleOpenDialog}
        onDelete={handleDelete}
        LoadingComponent={LoadingSkeleton}
      />

      <PaginationTable
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <QualityCommentDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        editMode={editMode}
        comment={selectedComment}
        onInputChange={handleInputChange}
        onSave={handleSave}
      />

      <ConfirmationDialog
        open={deleteConfirmOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        title="Eliminar Comentario"
        message={`¿Está seguro que desea eliminar el comentario de "${commentToDelete?.task_name}"?`}
        confirmText="Eliminar comentario"
      />
    </Box>
  );
};

export default QualityCommentsTable;
